import {
    DocumentTypeDto,
    EventTypeDto,
    SourceSystemDto,
    VehicleHistoryDto,
    VehicleHistoryEventAttributeDto,
    VehicleHistoryEventItemDto
} from "./vhs";

export type VhsDocType = DocumentTypeDto

export interface VhsEvent {
    id: string
    system: SourceSystemDto
    systemId: string
    vin: string
    username: string
    customerId: string
    createdDate: Date
    systemEventType: EventTypeDto
    lastScan?: Date
    documentId?: string
    documentType?: VhsDocType
    documentLocation?: string
    corNumber?: string
    licensePlate?: string
}

export interface VhsDocInfo {
    documentId: string
    type: VhsDocType
    status: EventTypeDto
    location?: string
}

function calculateLatestVhsDocuments(data: VhsEvent[]): VhsDocInfo[] {

    const byDocumentId = data.filter(e => e.system === 'VRS')
        .reduce((prev, currentValue) => {
            const {documentId} = currentValue
            if (documentId) {
                const items = prev.get(documentId) || []
                items.push(currentValue)
                prev.set(documentId, items)
            }
            return prev
        }, new Map<string, VhsEvent[]>())

    const latestState = data
        .filter(e => byDocumentId.has(e.documentId!))
        .sort((a, b) => b.createdDate.valueOf() - a.createdDate.valueOf())
        .reduce((prev, currentValue) => {
            if (!prev.has(currentValue.documentId!)) {
                prev.set(currentValue.documentId!, currentValue.systemEventType as EventTypeDto)
            }
            return prev
        }, new Map<string, EventTypeDto>())

    return Array.from(byDocumentId.values()).map(e => {
        // checken ob das richtig ist
        const sorted = e.sort((a, b) => b.createdDate.valueOf() - a.createdDate.valueOf())
        const first = sorted[0]!
        const d: VhsDocInfo = {
            documentId: first.documentId!,
            type: first.documentType!,
            status: latestState.get(first.documentId!)!,
            location: first.documentLocation
        }
        return d
    }).sort((a, b) => {
        return a.type.localeCompare(b.type)
    })
}

function toVhsEvent(e: VehicleHistoryEventItemDto): VhsEvent {
    const createdDate = new Date(e.createdDate)
    const lastScan = e.lastScan ? new Date(e.lastScan) : undefined
    return {
        id: e.id,
        system: e.system,
        systemId: e.systemId,
        vin: e.vin,
        username: e.username,
        customerId: e.customerId,
        createdDate: createdDate,
        systemEventType: e.systemEventType,
        lastScan: lastScan,
        documentId: e.documentId,
        documentType: e.documentType,
        documentLocation: e.attributes[VehicleHistoryEventAttributeDto.DOCUMENT_LOCATION] || undefined,
        corNumber: e.attributes[VehicleHistoryEventAttributeDto.COR_NUMBER] || undefined,
        licensePlate: e.attributes[VehicleHistoryEventAttributeDto.LICENSE_PLATE] || undefined,
    }
}

function dateCompare(dateA: string, dateB: string) {
    return Date.parse(dateB) - Date.parse(dateA)
}

function toSortedVhsEvents(dto: VehicleHistoryDto): VhsEvent[] {
    return dto
        .items
        .sort((a, b) => dateCompare(a.createdDate, b.createdDate))
        .map(e => toVhsEvent(e))
}

export {
    calculateLatestVhsDocuments,
    toVhsEvent,
    toSortedVhsEvents,
}
